import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { changeStatus } from "../../features/filters/filtersSlice";

const Sidebar = () => {
  const dispatch = useDispatch();

  return (
    <div className="sidebar">
      <nav>
        <ul className="space-y-4">
          <li>
            <a
              onClick={() => dispatch(changeStatus("ALL JOBS"))}
              className="main-menu menu-active"
              id="lws-alljobs-menu"
            >
              <i className="fa-solid fa-briefcase"></i>
              <span> All Available Jobs</span>
            </a>
            <ul className="space-y-6 lg:space-y-2 ">
              <li>
                <a
                  className="sub-menu"
                  onClick={() => dispatch(changeStatus("Internship"))}
                  id="lws-internship-menu"
                >
                  <i className="fa-solid fa-stop !text-[#FF5757]"></i>
                  Internship
                </a>
              </li>
              <li>
                <a
                  className="sub-menu"
                  onClick={() => dispatch(changeStatus("Full Time"))}
                  id="lws-fulltime-menu"
                >
                  <i className="fa-solid fa-stop !text-[#FF8A00]"></i>
                  Full Time
                </a>
              </li>
              <li>
                <a
                  className="sub-menu"
                  onClick={() => dispatch(changeStatus("Remote"))}
                  id="lws-remote-menu"
                >
                  <i className="fa-solid fa-stop !text-[#56E5C4]"></i>
                  Remote
                </a>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/add-new-job" className="main-menu" id="lws-addJob-menu">
              <i className="fa-solid fa-file-circle-plus"></i>
              <span>Add NewJob</span>
            </Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
